module.exports = __webpack_public_path__ + "0064e636baab9e56a033c786cddb464b.jpg";